export enum RejectReason {
  NA = { code: 'NA', description: 'ORDERS.NA' } as any,
  PRODUCT_UNAVAILABLE = {
    code: 'PRODUCT_UNAVAILABLE',
    description: 'ORDERS.PRODUCT_UNAVAILABLE',
  } as any,
  SUSPECT_ORDER = { code: 'SUSPECT_ORDER', description: 'ORDERS.SUSPECT_ORDER' } as any,
  OTHER = { code: 'OTHER', description: 'ORDERS.OTHER' } as any,
  ORDER_MISTAKE = { code: 'ORDER_MISTAKE', description: 'ORDERS.ORDER_MISTAKE' } as any,
  DELAYED_ORDER = { code: 'DELAYED_ORDER', description: 'ORDERS.DELAYED_ORDER' } as any,
  CLIENT_NOT_FOUND = { code: 'CLIENT_NOT_FOUND', description: 'ORDERS.CLIENT_NOT_FOUND' } as any,
  ADDRESS_NOT_FOUND = { code: 'ADDRESS_NOT_FOUND', description: 'ORDERS.ADDRESS_NOT_FOUND' } as any,
  ORDER_REJECT_BY_CUSTOMER = {
    code: 'ORDER_REJECT_BY_CUSTOMER',
    description: 'ORDERS.ORDER_REJECT_BY_CUSTOMER',
  } as any,
  ORDER_LOST = { code: 'ORDER_LOST', description: 'ORDERS.ORDER_LOST' } as any,
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/enums/reject-reason.enum.ts